// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VentasTelekino_container__A-wlw {
  animation: VentasTelekino_init__lBuap 1s;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  font-size: 16px;
}

/*--Header--*/
.VentasTelekino_container__A-wlw .VentasTelekino_header__39rMo {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.VentasTelekino_container__A-wlw .VentasTelekino_header__39rMo .VentasTelekino_titleContainer__rJPw6 {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.VentasTelekino_container__A-wlw .VentasTelekino_header__39rMo .VentasTelekino_titleContainer__rJPw6 h4 {
  text-align: center;
  font-size: 1.5rem;
  font-family: Roboto, sans-serif;
  font-weight: 300;
  margin-left: 10px;
}

.VentasTelekino_container__A-wlw .VentasTelekino_header__39rMo .VentasTelekino_uploadBtn__jPafK {
  width: 100%;
  margin-bottom: 10px;
}

.VentasTelekino_container__A-wlw .VentasTelekino_noResults__BVvX9 {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 2rem;
  font-weight: 300;
  height: 300px;
}

.VentasTelekino_container__A-wlw .VentasTelekino_header__39rMo .VentasTelekino_filters__SjHQv {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.VentasTelekino_container__A-wlw .VentasTelekino_header__39rMo .VentasTelekino_filters__SjHQv .VentasTelekino_filterButton__qmsKr {
  text-transform: capitalize;
  height: 3rem;
  width: 10rem;
  margin-bottom: 10px;
  border-radius: 5px;
}

.VentasTelekino_container__A-wlw .VentasTelekino_header__39rMo .VentasTelekino_filters__SjHQv .VentasTelekino_filterButton__qmsKr p {
  font-size: 0.9rem;
  margin-left: 5px;
  font-weight: 400;
}

/*---Información---*/
.VentasTelekino_container__A-wlw .VentasTelekino_data__ugzU2 .VentasTelekino_tableContainer__Dh94F {
  animation: VentasTelekino_init2__zv34b 0.5s;
  border-radius: 5px;
  max-height: 80vh;
  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);
}

.VentasTelekino_container__A-wlw .VentasTelekino_data__ugzU2 .VentasTelekino_tableContainer__Dh94F .VentasTelekino_iconbtn__GjY0c {
  transition: 0.3s;
  font-size: 2rem;
}

.VentasTelekino_container__A-wlw .VentasTelekino_data__ugzU2 .VentasTelekino_tableContainer__Dh94F .VentasTelekino_iconbtn__GjY0c:hover {
  transition: 0.3s;
  cursor: pointer;
  filter: brightness(0.7);
  scale: 1.1;
}

.VentasTelekino_container__A-wlw .VentasTelekino_data__ugzU2 .VentasTelekino_pagination__vLceL {
  margin-top: 50px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}

.VentasTelekino_container__A-wlw .VentasTelekino_loader__vKp8n {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
}

.VentasTelekino_container__A-wlw .VentasTelekino_loader__vKp8n {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
}

@media screen and (max-width: 500px) {
  .VentasTelekino_container__A-wlw .VentasTelekino_header__39rMo .VentasTelekino_titleContainer__rJPw6 h4 {
    font-size: 1.5rem;
  }
}

@keyframes VentasTelekino_init__lBuap {
  0% {
    transform: translateY(10px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes VentasTelekino_init2__zv34b {
  0% {
    transform: translateX(-10px);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/ProcessFiles/VentasTelekino/VentasTelekino.module.css"],"names":[],"mappings":"AAAA;EACE,wCAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;AACjB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,2CAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF","sourcesContent":[".container {\n  animation: init 1s;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  font-size: 16px;\n}\n\n/*--Header--*/\n.container .header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.container .header .titleContainer {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.container .header .titleContainer h4 {\n  text-align: center;\n  font-size: 1.5rem;\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n  margin-left: 10px;\n}\n\n.container .header .uploadBtn {\n  width: 100%;\n  margin-bottom: 10px;\n}\n\n.container .noResults {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  font-size: 2rem;\n  font-weight: 300;\n  height: 300px;\n}\n\n.container .header .filters {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.container .header .filters .filterButton {\n  text-transform: capitalize;\n  height: 3rem;\n  width: 10rem;\n  margin-bottom: 10px;\n  border-radius: 5px;\n}\n\n.container .header .filters .filterButton p {\n  font-size: 0.9rem;\n  margin-left: 5px;\n  font-weight: 400;\n}\n\n/*---Información---*/\n.container .data .tableContainer {\n  animation: init2 0.5s;\n  border-radius: 5px;\n  max-height: 80vh;\n  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);\n}\n\n.container .data .tableContainer .iconbtn {\n  transition: 0.3s;\n  font-size: 2rem;\n}\n\n.container .data .tableContainer .iconbtn:hover {\n  transition: 0.3s;\n  cursor: pointer;\n  filter: brightness(0.7);\n  scale: 1.1;\n}\n\n.container .data .pagination {\n  margin-top: 50px;\n  display: flex;\n  justify-content: space-evenly;\n  align-items: center;\n}\n\n.container .loader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 300px;\n}\n\n.container .loader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 300px;\n}\n\n@media screen and (max-width: 500px) {\n  .container .header .titleContainer h4 {\n    font-size: 1.5rem;\n  }\n}\n\n@keyframes init {\n  0% {\n    transform: translateY(10px);\n    opacity: 0;\n  }\n  100% {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n@keyframes init2 {\n  0% {\n    transform: translateX(-10px);\n    opacity: 0;\n  }\n  100% {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `VentasTelekino_container__A-wlw`,
	"init": `VentasTelekino_init__lBuap`,
	"header": `VentasTelekino_header__39rMo`,
	"titleContainer": `VentasTelekino_titleContainer__rJPw6`,
	"uploadBtn": `VentasTelekino_uploadBtn__jPafK`,
	"noResults": `VentasTelekino_noResults__BVvX9`,
	"filters": `VentasTelekino_filters__SjHQv`,
	"filterButton": `VentasTelekino_filterButton__qmsKr`,
	"data": `VentasTelekino_data__ugzU2`,
	"tableContainer": `VentasTelekino_tableContainer__Dh94F`,
	"init2": `VentasTelekino_init2__zv34b`,
	"iconbtn": `VentasTelekino_iconbtn__GjY0c`,
	"pagination": `VentasTelekino_pagination__vLceL`,
	"loader": `VentasTelekino_loader__vKp8n`
};
export default ___CSS_LOADER_EXPORT___;
